import React from 'react';
import TranslationText from '../../components/Translation/TranslationText.jsx';
import RimiLogoHeaderButton from '../../components/HeaderComponents/RimiLogoHeaderButton.jsx';

export function LoginHeader({ 
  initialData, 
  isMobileApp, 
  isLoginTypeSwitchHidden, 
  businessLogin, 
  onSwitchLogin 
}) {
  if (isMobileApp) {
    return null;
  }

  return (
    <header className="card-header">
      <RimiLogoHeaderButton initialData={initialData} />
      {!isLoginTypeSwitchHidden && (
        <a href="#" onClick={onSwitchLogin} className="link-button -with-right-icon">
          <TranslationText 
            text={businessLogin ? 'b2b_login_page_private_account_btn' : 'login_page_account_type_btn'} 
          />
          <svg height="24" viewBox="0 0 26 24" width="26" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd" stroke="#a12971" strokeWidth="2" transform="translate(2 4)">
              <path d="m10.4868162 3.0028106c.0751208-1.68496648-1.3545967-3.0028106-3.02542757-3.0028106-1.67083086 0-3.12114597 1.32915262-3.0254276 3.0028106.019386.33642788.336024 2.00241224.336024 2.00241224.261711 1.44587249 1.20435524 2.6684021 2.6894036 2.6684021 1.48504837 0 2.40911436-1.20435524 2.68940357-2.6684021 0 0 .3210807-1.66558049.336024-2.00241224z" />
              <path d="m14.9207579 15.3474114h-14.9207579l.25282575-2.8973992c.13812525-1.1029826 1.23949236-1.8606521 2.37801598-2.0819756l4.82953721-.63771862 4.88163706.65346972c1.2641288.2241506 2.3299549.924066 2.4119415 2.1990994z" />
              <path d="m18.3629441 4.99593371c.0601774-1.32996036-1.0835966-2.37074623-2.4204229-2.37074623-1.3364223 0-2.4967552 1.04926724-2.4204228 2.37074623.0157511.26615363.2689807 1.58036287.2689807 1.58036287.2092073 1.14135074.9632419 2.10701586 2.1514421 2.10701586 1.1882003 0 1.9272915-.95112562 2.1514422-2.10701586 0 0 .2568645-1.31420924.2689807-1.58036287z" />
              <path d="m15.941875 10.5009115 3.9886695.4802073c.9684923.1736663 1.8537863.7362642 1.932138 1.7649338l.1373175 2.6013588h-4.6445625" />
            </g>
          </svg>
        </a>
      )}
    </header>
  );
}